export { default } from './WideLayout';
